export default "__VITE_ASSET__Bv4QgwpQ__"